<template>
    <div>
    <!-- <br> -->
    <a-spin :spinning="spinning">
    <base-alert v-if="errors.length > 0 && showErrors == true" type="danger">
        <b>You have the following error(s):</b>
        <li v-for="error in errors" :key="error">{{ error }}</li>
    </base-alert>

    <div :class="['row', 'card-body', convertedJson.parentClass]">
        <div class="col-md-12" v-if="title != null"><h1>{{title}}</h1></div>
        <div class="col-md-12" v-if="description != null"><h4>{{description}}</h4><br></div>
        <div v-if="mode == 'tabs'" class="col-md-12">
                <a-tabs default-active-key="1" type="card">
                    <a-tab-pane v-if="!getConditionResult(groups).includes(false)" v-for="groups in settingsArray" :tab="groups['name']" :key="groups['sequence']" :class="groups.class" :style="groups.style">
                        <!-- {{settingsGroupHash}} -->
                        <div v-if="(groups['terminalSettings'] == null) == true && !getConditionResult(groups).includes(false)" class="row">
                            <div v-if="groups['mode'] == 'list'">
                                <div v-for="subGroup in groups['subGroups']" :class="subGroup.class" :key="subGroup['sequence']">
                                    <!-- <div v-if="getConditionResult(subGroup) != null"> -->
                                        <div class="col-md-12">
                                            <h2>{{subGroup.name}}</h2>
                                            <p v-if="subGroup.description">
                                                {{ subGroup.description }}
                                                <small v-if="subGroup.sub_description"> <br> {{ subGroup.sub_description }}</small>
                                            </p>
                                        </div>

                                        <div v-for="subSetting in subGroup['terminalSettings']" :class="subSetting.class" :style="subSetting.style" :key="subSetting['code']">
                                            <div v-if="isVisible(subSetting) == true" :class="[{indent: withCondition(subSetting['code'], 1) != null}]">
                                            <!-- <div v-if="isVisible(subSetting) == true" > -->
                                                <div v-if="subSetting['type'] == 'component'" :style="subSetting.style">
                                                  <div :is="subSetting['componentName']" :defaultValue="settingsModel[subSetting['code']]" :settingCode="subSetting['code']" @changeValue="changeValue"></div>
                                                </div>

                                                <div v-if="subSetting['type'] == 'text'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <base-input :label="subSetting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[subSetting['code']]" :required="subSetting['required']"/>
                                                </div>

                                                <div v-if="subSetting['type'] == 'label'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <h5>{{subSetting['label']}}</h5>
                                                    <!-- <base-input :label="subSetting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[subSetting['code']]" /> -->
                                                </div>

                                                <div v-if="subSetting['type'] == 'number'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> {{ subSetting['description'] }}</small>
                                                    <base-input v-if="subSetting['type'] == 'number'" :label="subSetting['label']" placeholder=""
                                                            input-classes="form-control" type="number"  v-model="settingsModel[subSetting['code']]"
                                                            :required="subSetting['required']"
                                                    />
                                                </div>

                                                <base-input v-if="subSetting['type'] == 'select'" :label="subSetting['label']" :style="subSetting.style" :required="subSetting['required']">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[subSetting['code']]">
                                                        <a-select-option v-for="option in subSetting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>

                                                <div v-if="subSetting['type'] == 'boolean'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <base-checkbox class="mb-3"  v-model="settingsModel[subSetting['code']]" :disabled="checkDisabled(subSetting) == false">
                                                        {{ subSetting['label'] }}
                                                        <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    </base-checkbox>
                                                </div>

                                                <base-input v-if="subSetting['type'] == 'multiple_select'" :label="subSetting['label']" :style="subSetting.style" :required="subSetting['required']">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <a-select mode="multiple" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[subSetting['code']]" >
                                                        <a-select-option v-for="option in subSetting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>

                                                <div v-if="subSetting['type'] == 'searchable_select'">
                                                    <base-input :label="subSetting['label']" :required="subSetting['required']">
                                                        <a-select
                                                            show-search
                                                            style="width: 100%"
                                                            placeholder="Please select"
                                                            optionFilterProp="children"
                                                            v-model="settingsModel[subSetting['code']]">
                                                            <a-select-option v-for="option in subSetting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                        </a-select>
                                                    </base-input>
                                                </div>

                                                <base-input v-if="subSetting['type'] == 'date'" :label="subSetting['label']" :style="subSetting.style" :required="subSetting['required']">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <br><a-date-picker @change="(date, dateString) => handleDatePickerChange(date, dateString, subSetting['code'])" v-model="settingsModel[subSetting['code']]" :format="dateFormat" input-classes="form-control"/>
                                                </base-input>

                                                <base-input v-if="subSetting['type'] == 'time'" :label="subSetting['label']" :style="subSetting.style" :required="subSetting['required']">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <br><a-time-picker valueFormat="H:mm:ss" format="H:mm:ss" v-model="settingsModel[subSetting['code']]" input-classes="form-control"/>
                                                </base-input>

                                                <base-input v-if="subSetting['type'] == 'radio'" :label="subSetting['label']" :style="subSetting.style" :required="subSetting['required']">
                                                    <br>
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <a-radio-group v-model="settingsModel[subSetting['code']]" >
                                                        <a-radio v-if="option.description == null" v-for="option in subSetting['options']" :style="radioStyle" :value="option.id" :key="option.id">
                                                          {{option.name}}
                                                        </a-radio>
                                                        <a-radio v-if="option.description != null" v-for="option in subSetting['options']" :style="radioStyle2" :value="option.id" :key="option.id">
                                                          <b>{{option.name}}</b>
                                                          <p style="padding-left: 25px;"><small>{{option.description}}</small></p>
                                                        </a-radio>
                                                    </a-radio-group>
                                                </base-input>

                                                <base-input v-if="subSetting['type'] == 'slider'" :label="subSetting['label']" :style="subSetting.style" :required="subSetting['required']">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <div v-if="subSetting.legend">
                                                        <br><span class="badge" style="background-color: #9D3FFA;">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{subSetting.legend}}
                                                    </div>
                                                    <div v-if="errorMessage[subSetting.code] != null" >
                                                        <br>
                                                        <base-alert type="warning" style="height: 50px;">
                                                            {{errorMessage[subSetting.code]}}
                                                        </base-alert>
                                                        <br>
                                                    </div>
                                                    <a-slider :defaultValue="[]" @change="checkSliderValue(subSetting)" v-model="settingsModel[subSetting['code']]" :marks="generateMarks(settingsModel[subSetting.maximumValue])" :step="1" :max="parseInt(settingsModel[subSetting.maximumValue])" :min="1" range/>
                                                </base-input>

                                                <base-input v-if="subSetting['type'] == 'switch'" class="row" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <div class="col-md-10">
                                                        <h3>{{subSetting['label']}}</h3>
                                                        <small>{{subSetting['description']}}</small>
                                                    </div>
                                                    <div class="float-right col-md-2"><a-switch v-model="settingsModel[subSetting['code']]" @change='onChange' :disabled="checkDisabled(subSetting) == false"/></div>
                                                </base-input>

                                            </div>

                                        </div>
                                    <!-- </div> -->
                                    <br>
                                </div>
                            </div>
                            <div v-else>
                                <a-tabs tabPosition="left" default-active-key="1">
                                    <a-tab-pane v-for="subGroup in groups['subGroups']" :tab="subGroup['name']" :key="subGroup['sequence']" class="row">
                                        <small class="col-md-12" v-if="subGroup['description']"> <br> {{ subGroup['description'] }}</small>
                                        <div  v-for="subSetting in subGroup['terminalSettings']" :class="subSetting.class" :style="subSetting.style" :key="subSetting['code']">
                                            <div v-if="isVisible(subSetting) == true" :class="[{indent: withCondition(subSetting['code'],1) != null}]">
                                                <!-- <base-input v-if="subSetting['type'] == 'text'" :label="subSetting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[subSetting['code']]" /> -->
                                                <div v-if="subSetting['type'] == 'component'" :style="subSetting.style">
                                                    <div :is="subSetting['componentName']" :defaultValue="settingsModel[subSetting['code']]" :settingCode="subSetting['code']" @changeValue="changeValue"></div>
                                                </div>

                                                <div v-if="subSetting['type'] == 'text'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                     <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <base-input :required="subSetting['required']" :label="subSetting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[subSetting['code']]" />
                                                </div>

                                                <div v-if="subSetting['type'] == 'label'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <h5>{{subSetting['label']}}</h5>
                                                    <!-- <base-input :label="subSetting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[subSetting['code']]" /> -->
                                                </div>

                                                <div v-if="subSetting['type'] == 'number'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'number'" :label="subSetting['label']" placeholder="" input-classes="form-control" type="number"  v-model="settingsModel[subSetting['code']]"/>
                                                </div>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'select'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[subSetting['code']]">
                                                        <a-select-option v-for="option in subSetting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>

                                                <div v-if="subSetting['type'] == 'boolean'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <base-checkbox class="mb-3"  v-model="settingsModel[subSetting['code']]" :disabled="checkDisabled(subSetting) == false">
                                                        {{ subSetting['label'] }}
                                                        <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    </base-checkbox>
                                                </div>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'multiple_select'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <a-select mode="multiple" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[subSetting['code']]">
                                                        <a-select-option v-for="option in subSetting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'date'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <br><a-date-picker @change="(date, dateString) => handleDatePickerChange(date, dateString, subSetting['code'])" v-model="settingsModel[subSetting['code']]" :format="dateFormat" input-classes="form-control"/>
                                                </base-input>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'time'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <br><a-time-picker valueFormat="H:mm:ss" format="H:mm:ss" v-model="settingsModel[subSetting['code']]" input-classes="form-control"/>
                                                </base-input>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'radio'" :label="subSetting['label']" :style="subSetting.style">
                                                    <br>
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <a-radio-group v-model="settingsModel[subSetting['code']]" >
                                                        <a-radio v-if="option.description == null" v-for="option in subSetting['options']" :style="radioStyle" :value="option.id" :key="option.id">
                                                          {{option.name}}
                                                        </a-radio>
                                                        <a-radio v-if="option.description != null" v-for="option in subSetting['options']" :style="radioStyle2" :value="option.id" :key="option.id">
                                                          <b>{{option.name}}</b>
                                                          <p style="padding-left: 25px;"><small>{{option.description}}</small></p>
                                                        </a-radio>
                                                    </a-radio-group>
                                                </base-input>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'slider'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <div v-if="subSetting.legend">
                                                        <br><span class="badge" style="background-color: #9D3FFA;">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{subSetting.legend}}
                                                    </div>
                                                    <div v-if="errorMessage[subSetting.code] != null" >
                                                        <br>
                                                        <base-alert type="warning" style="height: 50px;">
                                                            {{errorMessage[subSetting.code]}}
                                                        </base-alert>
                                                        <br>
                                                    </div>
                                                    <a-slider :defaultValue="[]" @change="checkSliderValue(subSetting)" v-model="settingsModel[subSetting['code']]" :marks="generateMarks(settingsModel[subSetting.maximumValue])" :step="1" :max="parseInt(settingsModel[subSetting.maximumValue])" :min="1" range/>
                                                </base-input>

                                                <base-input v-if="subSetting['type'] == 'switch'" class="row" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <div class="col-md-10">
                                                        <h3>{{subSetting['label']}}</h3>
                                                        <small>{{subSetting['description']}}</small>
                                                    </div>
                                                    <div class="float-right col-md-2"><a-switch v-model="settingsModel[subSetting['code']]" @change='onChange' :disabled="checkDisabled(subSetting) == false"/></div>
                                                </base-input>

                                            </div>
                                        </div>
                                    </a-tab-pane>
                                </a-tabs>
                            </div>
                        </div>
                        <div v-if="(groups['terminalSettings'] != null) == true && !getConditionResult(groups).includes(false)" class="row">
                            <div  v-for="setting in groups['terminalSettings']" :class="setting.class" :style="setting.style" :key="setting['code']">
                                <div v-if="isVisible(setting) == true" :class="[{indent: withCondition(setting['code'],1) != null}]">
                                    
                                    <div v-if="setting['type'] == 'component'" :style="setting.style">
                                        <div :is="setting['componentName']" :defaultValue="settingsModel[setting['code']]" :settingCode="setting['code']" @changeValue="changeValue"></div>
                                    </div>

                                    <div v-if="setting['type'] == 'text'" :style="setting.style">
                                        <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                         <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                        <base-input :required="setting['required']" :label="setting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[setting['code']]" />
                                    </div>

                                    <div v-if="setting['type'] == 'label'" :style="setting.style">
                                         <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                         <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                         <h5>{{setting['label']}}</h5>
                                         <!-- <base-input :label="subSetting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[subSetting['code']]" /> -->
                                     </div>


                                    <div v-if="setting['type'] == 'searchable_select'">
                                        <searchable-select :subSetting="setting" :disabled="checkDisabled(setting, true)" :key="externalSelect" @updateValues="updateHashValue"></searchable-select>
                                    </div>

                                    <div v-if="setting['type'] == 'number'" :style="setting.style">
                                        <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                        <small v-if="setting['description']"> <br> !!! {{ setting['description'] }}</small>
                                        <base-input :required="setting['required']" v-if="setting['type'] == 'number'" :label="setting['label']" placeholder="" input-classes="form-control" type="number"  v-model="settingsModel[setting['code']]"/>
                                    </div>

                                    <base-input :required="setting['required']" v-if="setting['type'] == 'select'" :label="setting['label']" :style="setting.style">
                                        <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                        <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                        <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[setting['code']]">
                                            <a-select-option v-for="option in setting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>

                                    <div v-if="setting['type'] == 'boolean'" :style="setting.style">
                                        <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                        <base-checkbox class="mb-3"  v-model="settingsModel[setting['code']]" :disabled="checkDisabled(setting) == false">
                                            {{ setting['label'] }}
                                            <small v-if="setting['description']"> <br> {{ setting['description']}}</small>
                                        </base-checkbox>
                                    </div>

                                    <base-input :required="setting['required']" v-if="setting['type'] == 'multiple_select'" :label="setting['label']" :style="setting.style">
                                        <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                        <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                        <a-select mode="multiple" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[setting['code']]">
                                            <a-select-option v-for="option in setting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>

                                    <!-- HHHHH -->
                                    <base-input :required="setting['required']" v-if="setting['type'] == 'date'" :label="setting['label']" :style="setting.style">
                                        <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                        <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                        <br><a-date-picker @change="(date, dateString) => handleDatePickerChange(date, dateString, setting['code'])" v-model="settingsModel[setting['code']]" :format="dateFormat" input-classes="form-control"/>
                                    </base-input>

                                    <base-input :required="setting['required']" v-if="setting['type'] == 'time'" :label="setting['label']" :style="setting.style">
                                        <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                        <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                        <br><a-time-picker valueFormat="H:mm:ss" format="H:mm:ss" v-model="settingsModel[setting['code']]" input-classes="form-control"/>
                                    </base-input>

                                    <base-input :required="setting['required']" v-if="setting['type'] == 'radio'" :label="setting['label']" :style="setting.style">
                                        <br>
                                        <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                        <a-radio-group v-model="settingsModel[setting['code']]" >
                                            <a-radio v-if="option.description == null" v-for="option in setting['options']" :style="radioStyle" :value="option.id" :key="option.id">
                                              {{option.name}}
                                            </a-radio>
                                            <a-radio v-if="option.description != null" v-for="option in setting['options']" :style="radioStyle2" :value="option.id" :key="option.id">
                                              <b>{{option.name}}</b>
                                              <p style="padding-left: 25px;"><small>{{option.description}}</small></p>
                                            </a-radio>
                                        </a-radio-group>
                                    </base-input>

                                    <base-input :required="setting['required']" v-if="setting['type'] == 'slider'" :label="setting['label']" :style="setting.style">
                                        <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                        <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                        <div v-if="setting.legend">
                                            <br><span class="badge" style="background-color: #9D3FFA;">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{setting.legend}}
                                        </div>
                                        <div v-if="errorMessage[setting.code] != null" >
                                            <br>
                                            <base-alert type="warning" style="height: 50px;">
                                                {{errorMessage[setting.code]}}
                                            </base-alert>
                                            <br>
                                        </div>
                                        <a-slider :defaultValue="[]" @change="checkSliderValue(setting)" v-model="settingsModel[setting['code']]" :marks="generateMarks(settingsModel[setting.maximumValue])" :step="1" :max="parseInt(settingsModel[setting.maximumValue])" :min="1" range/>
                                    </base-input>

                                    <base-input v-if="setting['type'] == 'switch'" class="row" :style="setting.style">
                                        <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                        <div class="col-md-10">
                                            <h3>{{setting['label']}}</h3>
                                            <small>{{setting['description']}}</small>
                                        </div>
                                        <div class="float-right col-md-2"><a-switch v-model="settingsModel[setting['code']]" @change='onChange' :disabled="checkDisabled(setting) == false"/></div>
                                    </base-input>
                                </div>
                            </div>
                        </div>
                    </a-tab-pane>
                </a-tabs>
        </div>
        <div v-if="mode == 'cards'" class="dynamic-form" style="width: 100%;">
            <a-collapse accordion activeKey="1">
                <a-collapse-panel v-for="groups in settingsArray" :class="groups.class" :style="groups.style" :key="groups['sequence']" :header="groups.name">
                  <div class="row">
                      <div v-for="setting in groups['terminalSettings']" :class="setting.class" :key="setting['code']">
                            <div v-if="isVisible(setting) == true" :class="[{indent: (withCondition(setting['code'],1) != null) && (setting.class == undefined)}]">

                                <div v-if="setting['type'] == 'component'" :style="setting.style">
                                    <div :is="setting['componentName']" :defaultValue="settingsModel[setting['code']]" :settingCode="setting['code']" @changeValue="changeValue"></div>
                                </div>

                                <div v-if="setting['type'] == 'text'" :style="setting.style">
                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                     <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                    <base-input :required="setting['required']" :label="setting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[setting['code']]" :disabled="checkDisabled(setting) == true"/>
                                </div>

                                <div v-if="setting['type'] == 'label'" :style="setting.style">
                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                    <h5>{{setting['label']}}</h5>
                                    <!-- <base-input :label="subSetting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[subSetting['code']]" /> -->
                                </div>

                                <div v-if="setting['type'] == 'searchable_select'">
                                    <searchable-select :subSetting="setting" :disabled="checkDisabled(setting, true)" :key="externalSelect" @updateValues="updateHashValue"></searchable-select>
                                </div>

                                <div v-if="setting['type'] == 'cascader'" :style="setting.style">
                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                    <h5>{{setting['label']}}</h5>
                                    <!-- :disabled="checkDisabled(setting) == true" -->
                                    <a-cascader v-model="settingsModel[setting['code']]" :options="setting['options']" placeholder="Please select category" style="width: 100%" :disabled="checkDisabled(setting) == true"/>
                                </div>


                                <div v-if="setting['type'] == 'number'" :style="setting.style">
                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                    <base-input :required="setting['required']" v-if="setting['type'] == 'number'" :label="setting['label']" placeholder="" input-classes="form-control" type="number"  v-model="settingsModel[setting['code']]" :disabled="checkDisabled(setting) == true"/>
                                </div>

                                <base-input :required="setting['required']" v-if="setting['type'] == 'select'" :label="setting['label']" :style="setting.style">
                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                    <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[setting['code']]" :disabled="checkDisabled(setting) == true">
                                        <a-select-option v-for="option in setting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>


                                <div v-if="setting['type'] == 'boolean'" :style="setting.style">
                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                    <base-checkbox class="mb-3"  v-model="settingsModel[setting['code']]" :disabled="checkDisabled(setting) == false">
                                        {{ setting['label'] }} 
                                        <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                    </base-checkbox>
                                </div>

                                <base-input :required="setting['required']" v-if="setting['type'] == 'multiple_select'" :label="setting['label']" :style="setting.style">
                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                    <a-select mode="multiple" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[setting['code']]" :disabled="checkDisabled(setting) == true">
                                        <a-select-option v-for="option in setting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>

                                <base-input :required="setting['required']" v-if="setting['type'] == 'date'" :label="setting['label']" :style="setting.style" >
                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                    <br><a-date-picker @change="(date, dateString) => handleDatePickerChange(date, dateString, setting['code'])" v-model="settingsModel[setting['code']]" :format="dateFormat" input-classes="form-control" :disabled="checkDisabled(setting) == true"/>
                                </base-input>

                                <base-input :required="setting['required']" v-if="setting['type'] == 'range'" :label="setting['label']" :style="setting.style">
                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                    <br><a-range-picker v-model="settingsModel[setting['code']]" input-classes="form-control"/>
                                </base-input>

                                <base-input :required="setting['required']" v-if="setting['type'] == 'time'" :label="setting['label']" :style="setting.style">
                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                    <br><a-time-picker valueFormat="H:mm:ss" format="H:mm:ss" v-model="settingsModel[setting['code']]" input-classes="form-control"/>
                                </base-input>

                                <base-input :required="setting['required']" v-if="setting['type'] == 'radio'" :label="setting['label']" :style="setting.style">
                                    <br>
                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                    <a-radio-group v-model="settingsModel[setting['code']]" >
                                        <a-radio v-if="option.description == null" v-for="option in setting['options']" :style="radioStyle" :value="option.id" :key="option.id">
                                          {{option.name}}
                                        </a-radio>
                                        <a-radio v-if="option.description != null" v-for="option in setting['options']" :style="radioStyle2" :value="option.id" :key="option.id">
                                          <b>{{option.name}}</b>
                                          <p style="padding-left: 25px;"><small>{{option.description}}</small></p>
                                        </a-radio>
                                    </a-radio-group>
                                </base-input>

                                <base-input :required="setting['required']" v-if="setting['type'] == 'slider'" :label="setting['label']" :style="setting.style">
                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                    <div v-if="setting.legend">
                                        <br><span class="badge" style="background-color: #9D3FFA;">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{setting.legend}}
                                    </div>
                                    <div v-if="errorMessage[setting.code] != null" >
                                        <br>
                                        <base-alert type="warning" style="height: 50px;">
                                            {{errorMessage[setting.code]}}
                                        </base-alert>
                                        <br>
                                    </div>
                                    <a-slider :defaultValue="[]" @change="checkSliderValue(setting)" v-model="settingsModel[setting['code']]" :marks="generateMarks(settingsModel[setting.maximumValue])" :step="1" :max="parseInt(settingsModel[setting.maximumValue])" :min="1" range/>
                                </base-input>

                                <base-input v-if="setting['type'] == 'switch'" class="row" :style="setting.style">
                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                    <div class="col-md-10">
                                        <p>{{setting['label']}}</p>
                                        <small>{{setting['description']}}</small>
                                    </div>
                                    <div class="float-right col-md-2"><a-switch v-model="settingsModel[setting['code']]" @change='onChange' :disabled="checkDisabled(setting) == true"/></div>
                                </base-input>

                            </div>
                        </div>
                    </div>
                </a-collapse-panel>
            </a-collapse>
        </div>
        <div v-if="mode == 'list'" class="row col-md-12">
                <div  v-for="groups in settingsArray" :class="groups.class" :style="groups.style" :key="groups['sequence']">
                    <div v-if="(groups['terminalSettings'] == null) == true && !getConditionResult(groups).includes(false)" class="row">
                        <h2 class="col-md-12" v-if="groups['name'] != undefined">{{groups["name"]}}</h2>
                            <div v-if="groups['mode'] == 'list'">
                                <div v-for="subGroup in groups['subGroups']" :class="subGroup.class" :style="subGroup.style" :key="subGroup['code']">
                                    <div class="col-md-12">
                                        <h3>{{subGroup.name}}</h3>
                                        <small v-if="subGroup['description']"> <br> {{ subGroup['description'] }}</small>
                                    </div>
                                    <div  v-for="subSetting in subGroup['terminalSettings']" :class="subSetting.class" :key="subSetting['code']">
                                        <div v-if="isVisible(subSetting) == true" :class="[{indent: withCondition(subSetting['code'],1) != null}]">
                                                <div v-if="subSetting['type'] == 'component'" :style="subSetting.style">
                                                    <div :is="subSetting['componentName']" :defaultValue="settingsModel[subSetting['code']]" :settingCode="subSetting['code']" @changeValue="changeValue"></div>
                                                </div>

                                                <div v-if="subSetting['type'] == 'text'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                     <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <base-input :required="subSetting['required']" :label="subSetting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[subSetting['code']]" />
                                                </div>

                                                <div v-if="subSetting['type'] == 'label'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <h5>{{subSetting['label']}}</h5>
                                                    <!-- <base-input :label="subSetting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[subSetting['code']]" /> -->
                                                </div>

                                                <div v-if="subSetting['type'] == 'number'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'number'" :label="subSetting['label']" placeholder="" input-classes="form-control" type="number"  v-model="settingsModel[subSetting['code']]"/>
                                                </div>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'select'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[subSetting['code']]">
                                                        <a-select-option v-for="option in subSetting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>

                                                <div v-if="subSetting['type'] == 'boolean'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <base-checkbox class="mb-3"  v-model="settingsModel[subSetting['code']]" :disabled="checkDisabled(subSetting) == false">
                                                        {{ subSetting['label'] }}
                                                        <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    </base-checkbox>
                                                </div>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'multiple_select'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <a-select mode="multiple" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[subSetting['code']]">
                                                        <a-select-option v-for="option in subSetting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>

                                                 <div v-if="subSetting['type'] == 'searchable_select'">
                                                    <searchable-select :subSetting="subSetting"></searchable-select>
                                                </div>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'date'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <br><a-date-picker @change="(date, dateString) => handleDatePickerChange(date, dateString, subSetting['code'])" v-model="settingsModel[subSetting['code']]" :format="dateFormat" input-classes="form-control"/>
                                                </base-input>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'time'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <br><a-time-picker valueFormat="H:mm:ss" format="H:mm:ss" v-model="settingsModel[subSetting['code']]" input-classes="form-control"/>
                                                </base-input>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'radio'" :label="subSetting['label']" :style="subSetting.style">
                                                    <br>
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <a-radio-group v-model="settingsModel[subSetting['code']]" >
                                                        <a-radio v-if="option.description == null" v-for="option in subSetting['options']" :style="radioStyle" :value="option.id" :key="option.id">
                                                          {{option.name}}
                                                        </a-radio>
                                                        <a-radio v-if="option.description != null" v-for="option in subSetting['options']" :style="radioStyle2" :value="option.id" :key="option.id">
                                                          <b>{{option.name}}</b>
                                                          <p style="padding-left: 25px;"><small{{option.description}}</small></p>
                                                        </a-radio>
                                                    </a-radio-group>
                                                </base-input>

                                               <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'slider'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <div v-if="subSetting.legend">
                                                        <br><span class="badge" style="background-color: #9D3FFA;">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{subSetting.legend}}
                                                    </div>
                                                    <div v-if="errorMessage[subSetting.code] != null" >
                                                        <br>
                                                        <base-alert type="warning" style="height: 50px;">
                                                            {{errorMessage[subSetting.code]}}
                                                        </base-alert>
                                                        <br>
                                                    </div>
                                                    <a-slider :defaultValue="[]" @change="checkSliderValue(subSetting)" v-model="settingsModel[subSetting['code']]" :marks="generateMarks(settingsModel[subSetting.maximumValue])" :step="1" :max="parseInt(settingsModel[subSetting.maximumValue])" :min="1" range/>
                                                </base-input>

                                                <base-input v-if="subSetting['type'] == 'switch'" class="row" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <div class="col-md-10">
                                                        <h3>{{subSetting['label']}}</h3>
                                                        <small>{{subSetting['description']}}</small>
                                                    </div>
                                                    <div class="float-right col-md-2"><a-switch v-model="settingsModel[subSetting['code']]" @change='onChange' :disabled="checkDisabled(subSetting) == false"/></div>
                                                </base-input>

                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <a-tabs type="card" default-active-key="1">
                                    <a-tab-pane v-for="subGroup in groups['subGroups']" :tab="subGroup['name']" :key="subGroup['sequence']">
                                        <small v-if="subGroup['description']"> <br> {{ subGroup['description'] }}</small>
                                        <div  v-for="subSetting in subGroup['terminalSettings']" :key="subSetting['code']">
                                            <div v-if="isVisible(subSetting) == true" :class="[{indent: withCondition(subSetting['code'],1) != null}]">
                                                <div v-if="subSetting['type'] == 'component'" :style="subSetting.style">
                                                  <div :is="subSetting['componentName']" :defaultValue="settingsModel[subSetting['code']]" :settingCode="subSetting['code']" @changeValue="changeValue"></div>
                                                </div>

                                                <div v-if="subSetting['type'] == 'text'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                     <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <base-input :required="subSetting['required']" :label="subSetting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[subSetting['code']]" />
                                                </div>

                                                <div v-if="subSetting['type'] == 'label'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <h5>{{subSetting['label']}}</h5>
                                                    <!-- <base-input :label="subSetting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[subSetting['code']]" /> -->
                                                </div>


                                                <div v-if="subSetting['type'] == 'number'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'number'" :label="subSetting['label']" placeholder="" input-classes="form-control" type="number"  v-model="settingsModel[subSetting['code']]"/>
                                                </div>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'select'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[subSetting['code']]">
                                                        <a-select-option v-for="option in subSetting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>

                                                <div v-if="subSetting['type'] == 'boolean'" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <base-checkbox class="mb-3"  v-model="settingsModel[subSetting['code']]" :disabled="checkDisabled(subSetting) == false">
                                                        {{ subSetting['label'] }}
                                                        <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    </base-checkbox>
                                                </div>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'multiple_select'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <!-- showSearch :notFoundContent="null" @search="handleSearch"  -->
                                                    <a-select mode="multiple" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[subSetting['code']]">
                                                        <a-select-option v-for="option in subSetting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'date'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <br><a-date-picker @change="(date, dateString) => handleDatePickerChange(date, dateString, subSetting['code'])" v-model="settingsModel[subSetting['code']]" :format="dateFormat" input-classes="form-control"/>
                                                </base-input>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'time'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <br><a-time-picker valueFormat="H:mm:ss" format="H:mm:ss" v-model="settingsModel[subSetting['code']]" input-classes="form-control"/>
                                                </base-input>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'radio'" :label="subSetting['label']" :style="subSetting.style">
                                                    <br>
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <a-radio-group v-model="settingsModel[subSetting['code']]" >
                                                        <a-radio v-if="option.description == null" v-for="option in subSetting['options']" :style="radioStyle" :value="option.id" :key="option.id">
                                                          {{option.name}}
                                                        </a-radio>
                                                        <a-radio v-if="option.description != null" v-for="option in subSetting['options']" :style="radioStyle2" :value="option.id" :key="option.id">
                                                          <b>{{option.name}}</b>
                                                          <p style="padding-left: 25px;"><small>{{option.description}}</small></p>
                                                        </a-radio>
                                                    </a-radio-group>
                                                </base-input>

                                                <base-input :required="subSetting['required']" v-if="subSetting['type'] == 'slider'" :label="subSetting['label']" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <small v-if="subSetting['description']"> <br> {{ subSetting['description'] }}</small>
                                                    <div v-if="subSetting.legend">
                                                        <br><span class="badge" style="background-color: #9D3FFA;">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{subSetting.legend}}
                                                    </div>
                                                    <div v-if="errorMessage[subSetting.code] != null" >
                                                        <br>
                                                        <base-alert type="warning" style="height: 50px;">
                                                            {{errorMessage[subSetting.code]}}
                                                        </base-alert>
                                                        <br>
                                                    </div>
                                                    <a-slider :defaultValue="[]" @change="checkSliderValue(subSetting)" v-model="settingsModel[subSetting['code']]" :marks="generateMarks(settingsModel[subSetting.maximumValue])" :step="1" :max="parseInt(settingsModel[subSetting.maximumValue])" :min="1" range/>
                                                </base-input>

                                                <base-input v-if="subSetting['type'] == 'switch'" class="row" :style="subSetting.style">
                                                    <h3 v-if="subSetting['header']"> <br> {{ subSetting['header'] }}</h3>
                                                    <div class="col-md-10">
                                                        <h3>{{subSetting['label']}}</h3>
                                                        <small>{{subSetting['description']}}</small>
                                                    </div>
                                                    <div class="float-right col-md-2"><a-switch v-model="settingsModel[subSetting['code']]" @change='onChange' :disabled="checkDisabled(subSetting) == false"/></div>
                                                </base-input>

                                            </div>
                                        </div>
                                    </a-tab-pane>
                                </a-tabs>
                            </div>
                    </div>
                    <div v-if="(groups['terminalSettings'] != null) == true && !getConditionResult(groups).includes(false)" class="row">
                        <h2 class="col-md-12" v-if="groups['name'] != undefined">{{groups["name"]}}</h2>
                        <div v-for="setting in groups['terminalSettings']" :class="setting.class" :key="setting['code']">
                            <div v-if="isVisible(setting) == true" :class="[{indent: (withCondition(setting['code'],1) != null) && (setting.class == undefined)}]">
                                <!-- :class="[{indent: withCondition(setting['code'],1) != null}]" -->
                                <!-- <base-input v-if="setting['type'] == 'text'" :label="setting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[setting['code']]" /> -->
                                                <div v-if="setting['type'] == 'component'" :style="setting.style">
                                                    <div :is="setting['componentName']" :defaultValue="settingsModel[setting['code']]" :settingCode="setting['code']" @changeValue="changeValue"></div>
                                                </div>

                                                <div v-if="setting['type'] == 'text'" :style="setting.style">
                                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                                     <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                                    <base-input :required="setting['required']" :label="setting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[setting['code']]" />
                                                </div>

                                                <div v-if="setting['type'] == 'label'" :style="setting.style">
                                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                                    <h5>{{setting['label']}}</h5>
                                                    <!-- <base-input :label="subSetting['label']" placeholder="" input-classes="form-control" v-model="settingsModel[subSetting['code']]" /> -->
                                                </div>

                                                <div v-if="setting['type'] == 'number'" :style="setting.style">
                                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                                    <base-input :required="setting['required']" v-if="setting['type'] == 'number'" :label="setting['label']" placeholder="" input-classes="form-control" type="number"  v-model="settingsModel[setting['code']]"/>
                                                </div>

                                                <base-input :required="setting['required']" v-if="setting['type'] == 'select'" :label="setting['label']" :style="setting.style">
                                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                                    <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[setting['code']]">
                                                        <a-select-option v-for="option in setting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>

                                                <div v-if="setting['type'] == 'boolean'" :style="setting.style">
                                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                                    <base-checkbox class="mb-3"  v-model="settingsModel[setting['code']]" :disabled="checkDisabled(setting) == false">
                                                        <span v-b-tooltip.hover.right="setting['code']">{{ setting['label'] }}</span>
                                                        <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                                    </base-checkbox>
                                                </div>

                                                <base-input :required="setting['required']" v-if="setting['type'] == 'multiple_select'" :label="setting['label']" :style="setting.style">
                                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                                    <a-select mode="multiple" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="settingsModel[setting['code']]">
                                                        <a-select-option v-for="option in setting['options']" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>

                                                <div v-if="setting['type'] == 'searchable_select'">
                                                    <searchable-select :subSetting="setting"></searchable-select>
                                                </div>

                                                <base-input :required="setting['required']" v-if="setting['type'] == 'date'" :label="setting['label']" :style="setting.style">
                                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                                    <br><a-date-picker @change="(date, dateString) => handleDatePickerChange(date, dateString, setting['code'])" v-model="settingsModel[setting['code']]" :format="dateFormat" input-classes="form-control"/>
                                                </base-input>

                                                <base-input :required="setting['required']" v-if="setting['type'] == 'range'" :label="setting['label']" :style="setting.style">
                                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                                    <br><a-range-picker v-model="settingsModel[setting['code']]" input-classes="form-control"/>
                                                </base-input>

                                                <base-input :required="setting['required']" v-if="setting['type'] == 'time'" :label="setting['label']" :style="setting.style">
                                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                                    <br><a-time-picker valueFormat="H:mm:ss" format="H:mm:ss" v-model="settingsModel[setting['code']]" input-classes="form-control"/>
                                                </base-input>

                                                <base-input :required="setting['required']" v-if="setting['type'] == 'radio'" :label="setting['label']" :style="setting.style">
                                                    <br>
                                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                                    <a-radio-group v-model="settingsModel[setting['code']]" >
                                                        <a-radio v-if="option.description == null" v-for="option in setting['options']" :style="radioStyle" :value="option.id" :key="option.id">
                                                          {{option.name}}
                                                        </a-radio>
                                                        <a-radio v-if="option.description != null" v-for="option in setting['options']" :style="radioStyle2" :value="option.id" :key="option.id">
                                                          <b>{{option.name}}</b>
                                                          <p style="padding-left: 25px;"><small>{{option.description}}</small></p>
                                                        </a-radio>
                                                    </a-radio-group>
                                                </base-input>

                                                <base-input :required="setting['required']" v-if="setting['type'] == 'slider'" :label="setting['label']" :style="setting.style">
                                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                                    <small v-if="setting['description']"> <br> {{ setting['description'] }}</small>
                                                    <div v-if="setting.legend">
                                                        <br><span class="badge" style="background-color: #9D3FFA;">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{setting.legend}}
                                                    </div>
                                                    <div v-if="errorMessage[setting.code] != null" >
                                                        <br>
                                                        <base-alert type="warning" style="height: 50px;">
                                                            {{errorMessage[setting.code]}}
                                                        </base-alert>
                                                        <br>
                                                    </div>
                                                    <a-slider :defaultValue="[]" @change="checkSliderValue(setting)" v-model="settingsModel[setting['code']]" :marks="generateMarks(settingsModel[setting.maximumValue])" :step="1" :max="parseInt(settingsModel[setting.maximumValue])" :min="1" range/>
                                                </base-input>

                                                <base-input v-if="setting['type'] == 'switch'" class="row" :style="setting.style">
                                                    <h3 v-if="setting['header']"> <br> {{ setting['header'] }}</h3>
                                                    <div class="col-md-10">
                                                        <h3>{{setting['label']}}</h3>
                                                        <small>{{setting['description']}}</small>
                                                    </div>
                                                    <div class="float-right col-md-2"><a-switch v-model="settingsModel[setting['code']]" @change='onChange' :disabled="checkDisabled(setting) == false"/></div>
                                                </base-input>

                            </div>
                        </div>
                    </div>
                    <br>
                </div>
        </div>

            <!-- <hr class="my-3">
            <h5 class="navbar-heading text-muted">Sample Value</h5> <br>
            {{ settingsModel }}   -->
            <!-- {{ errors }} -->
    </div>
    </a-spin>
    </div>
</template>

<script>
import HTTPRequest from '../controllers/httpRequest.js'
import { mapState, mapActions } from 'vuex'
import secureStorage from '../controllers/secureStorage.js';
import axios from "axios"

import FilterBar from './FilterBar'
import SearchableSelect from './SearchableSelect'
import ValidateField from '../components/validateFormUtils.js'
// var ObjGen = require('../../node_modules/objgen/objgen.js').ObjGen;
var conditionResult = []

import moment from 'moment';

export default {
    components: {
      SearchableSelect
    },
  mounted: async function(){
    // console.log(this.$attrs.formSettings)
    // this.settingsModel = this.$attrs.formSettings
    console.log("-------------")
    console.log(this.$attrs.formSettings)
    this.convertedJson = this.$attrs.convertedJson
    if(this.$attrs.showErrors != null) this.showErrors = this.$attrs.showErrors
    if(this.convertedJson != null){
        this.processJSON()
    }
  },
  computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'categoriesOptions']),
        // dynamicComponent(path) {
        //   return () => import(path);
        // }
        // ...mapState(['endPoint', 'currentProfile', 'parameters', 'serverType']
    },
  data () {
    return {
      showErrors: true,
      spinning: false,
      externalSelect: 0,
      externalDisabled: true,
      description: null,
      activeKey:  "1",
      settingsGroupHash: {},
      errors: [],
      title: null,
      errorMessage: {},
      activeKey: [1],
      dateFormat: 'MM-DD-YYYY',
      mode: "list",
      settingsModel: {},
      settingsArray: [],
      subGroupSettingsArray: [],
      convertedJson: null,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      radioStyle2: {
        display: 'block',
        height: '60px',
        lineHeight: '30px',
      },
    }
  },
  watch: {
    settingsModel: {
        handler: function() {
          // Run only if there's valueUpdated listener
          if (!this.$listeners.valueUpdated) { return; }

          var errors = this.validateForm()
          var returnSettings = this.settingsModel
          this.$emit('valueUpdated', returnSettings, this.settingsGroupHash, errors)
          this.externalSelect++
        },
        deep: true
    }

    // settingsModel(){
    //     var returnSettings = this.settingsModel
    //     this.$emit('valueUpdated', returnSettings)
    // },
  },
  methods: {
    moment,
    updateHashValue(code, value){
        this.settingsModel[code] = value
    },
    checkDisabled(setting, external=false){
         if(setting.code == "override_intro_date")
            // console.log(setting.disabled)
         var return_value = null

         if(setting.disabled == undefined){
             return_value = true;
         }else{
            var code_checker = setting.disabled.code
            var value_checker = setting.disabled.value
            if(this.settingsModel[code_checker] == undefined){
                return_value = true;
            }else{
                if(this.settingsModel[code_checker].toString() == value_checker.toString())
                    return_value = false;
                else
                    return_value = true;
            }
         }

         return return_value;
     },
    validateForm(){
      this.errors = [];
      this.settingsArray.map( (value) => {
        if (value["terminalSettings"] != null){
          var terminalSettings = value["terminalSettings"]
          for (var j=0; j < terminalSettings.length; j++){
            if (terminalSettings[j]["required"] == true){
              if (!terminalSettings[j]["class"]) terminalSettings[j]["class"] = "col-md-12 no-gutter"
              this.errors.push(ValidateField.required(terminalSettings[j]["code"], this.settingsModel[terminalSettings[j]["code"]]));
            }
          }
        } else if (value["subGroups"] != null ){
          for (var i=0; i < value["subGroups"].length; i++){
            var terminalSettings = value["subGroups"][i]["terminalSettings"]
            for (var j=0; j < terminalSettings.length; j++){
              if (!terminalSettings[j]["class"]) terminalSettings[j]["class"] = "col-md-12 no-gutter"
              if (terminalSettings[j]["required"] == true){
                this.errors.push(ValidateField.required(terminalSettings[j]["code"], this.settingsModel[terminalSettings[j]["code"]]));
              }
            }
          }
        }
      })

      return this.errors = this._.compact(this.errors);
    },
    addCustomErrors(errors) {
        // To add Custom Errors from parent components
        this.errors = errors;
    },
     withCondition(codeSetting, type){
        var result = null
        // console.log(this.settingsArray)
        if (type == 1){
            this.settingsArray.map( (value) => {
                if( value["terminalSettings"] != null){
                    var terminalSettings = value["terminalSettings"]
                    // console.log("wow")
                    for(var j=0; j < terminalSettings.length; j++){
                        if(codeSetting == terminalSettings[j]["code"]){
                            result = (terminalSettings[j]["conditions"] == undefined) ? null : terminalSettings[j]
                        }
                    }
                } else if (value["subGroups"] != null ){
                    for(var i=0; i < value["subGroups"].length; i++){
                        var terminalSettings = value["subGroups"][i]["terminalSettings"]
                        for(var j=0; j < terminalSettings.length; j++){
                            if(codeSetting == terminalSettings[j]["code"]){
                                result = (terminalSettings[j]["conditions"] == undefined) ? null : terminalSettings[j]
                            }
                        }
                    }
                }
            })
        }
        return result
     },
     getConditionResult(setting){
        //  console.log(">>>>>>>>")
        //  console.log(setting)
         if(setting["conditions"] != undefined){
             var c = setting["conditions"]
             for( var i = 0; i < c.length; i++){

                if(this.settingsModel[c[i]["code"]] != undefined){
                    if(c[i]["operator"] == undefined || c[i]["operator"] == '=' ){
                        conditionResult.push(this.settingsModel[c[i]["code"]].toString()  == c[i]["value"].toString())
                    }else{
                        // check AccountSystemModule for adding new operator
                        // operations on data()
                        switch(c[i]["operator"]) {
                            case "NOT NULL":
                                conditionResult.push(this.settingsModel[c[i]["code"]].toString()  != null && this.settingsModel[c[i]["code"]].toString()  != '')
                                break;
                            case "IS NULL":
                                conditionResult.push(this.settingsModel[c[i]["code"]].toString()  == '' || this.settingsModel[c[i]["code"]].toString()  == undefined)
                                break;
                            case ">":
                                conditionResult.push(parseInt(this.settingsModel[c[i]["code"]])  > parseInt(c[i]["value"].toString()))
                                break;
                            case "<":
                                conditionResult.push(parseInt(this.settingsModel[c[i]["code"]])  < parseInt(c[i]["value"].toString()))
                                break;
                            case ">=":
                                conditionResult.push(parseInt(this.settingsModel[c[i]["code"]])  >= parseInt(c[i]["value"].toString()))
                                break;
                            case "<=":
                                conditionResult.push(parseInt(this.settingsModel[c[i]["code"]])  <= parseInt(c[i]["value"].toString()))
                                break;
                            case "IN":
                                // convert value to string
                                const value = c[i]["value"].toString()
                                // change value to array
                                // split by ","
                                // trim space
                                let arr = value.split(",").map(function (value) {
                                    return value.trim();
                                });
                                const setting =this.settingsModel[c[i]["code"]].toString()
                                conditionResult.push(arr.includes(setting))
                                break;
                        }
                    }
                }else{
                    conditionResult.push(false)
                }
                var checker = this.withCondition(c[i]["code"], 1)
                if(checker != null)
                    this.getConditionResult(checker)
             }
         }else {
             conditionResult = []
             conditionResult.push(true)
         }
        //  this.conditions.push(result)
        return conditionResult
     },
     isVisible(setting) {
        var result = this.withCondition(setting["code"],1)

        if(result != null){
            conditionResult = []
            var conditions = this.getConditionResult(setting)
            if(conditions.includes(false))
                return false
            else
                return true

        }else{
            conditionResult = []
            return true
        }
     },

     generateMarks( maxValue ){
         var generatedMark = {}
         for(var i = 1; i <= maxValue; i++){
             generatedMark[i] = "0"
         }
         return generatedMark
     },

     checkSliderValue(setting){
        var slider_value = this.settingsModel[setting.code]
        var slide_value_array =  Array.from({length: slider_value[1]-slider_value[0]+1},(v,k)=>k+slider_value[0])
        // console.log(slide_value_array)
        var valid = []

        if(setting.validator != undefined){
            for(var i=0; i < setting.validator.length; i++){
               var checker = this.settingsModel[setting.validator[i].code]
               if(checker != undefined){
                   if(slide_value_array.includes(checker[0])){
                       valid.push(false)
                   }  else  {
                       valid.push(true)
                   }

                   if(slide_value_array.includes(checker[1])){
                       valid.push(false)
                   } else  {
                       valid.push(true)
                   }

               }
            }

            if(valid.includes(false)){
                // this.settingsModel[setting.code] = []
                this.errorMessage[setting.code] = "Invalid range selected. Values must not overlap"
            } else {
                this.errorMessage[setting.code] = null
            }
        }


     },

     async processJSON() {
        //  Add parameters

        //console.log(this.convertedJson instanceof Object)
				//console.log(this.convertedJson)
        this.spinning = true
        var groups = []

        if(this.convertedJson.constructor.name ==  "String"){
            this.mode = JSON.parse(this.convertedJson)["mode"]
            this.title = JSON.parse(this.convertedJson)["title"]
            this.description = JSON.parse(this.convertedJson)["description"]
            groups = JSON.parse(this.convertedJson)["groups"]
			// console.log("I am here")
        } else {
            this.mode = this.convertedJson["mode"]
            this.title = this.convertedJson["title"]
            this.description = this.convertedJson["description"]
            groups = this.convertedJson["groups"]
						// console.log(this.convertedJson.constructor.name)
						// console.log("ANDITO KA!!")
        }

        groups.sort(function (a, b) { return a.sequence - b.sequence;});

        for(var j = 0; j < groups.length; j++){
            //console.log(groups[]["name"])
            if (groups["class"] == undefined) groups["class"] = "col-md-12 no-gutter"
            var types = ["text", "number", "select", "searchable_select", "multiple_select", "boolean", "date", "time", "radio", "switch", "slider", "label", "range", "cascader", "component"]

            var subgroups = groups[j]["subGroups"]
            if(subgroups != undefined){
            // console.log("OKAY NAMAN YUNG SUBGROUPS!!")
            // groups.splice(j, 1);
            var subSettingArray = [];
            var settingKeysArray = [];

            for(var x = 0; x < subgroups.length; x++){
                if (subgroups["class"] == undefined) subgroups["class"] = "col-md-12 no-gutter"
                var subSettings = subgroups[x]["terminalSettings"]
                // console.log("*********")
                // console.log(subSettings)

                for(var y = 0; y < subSettings.length; y++){
                    var subSetting = subSettings[y]

                    settingKeysArray.push(subSetting["code"])

                    if(types.includes(subSetting["type"])){
                       if(subSetting["code"] != "" || subSetting["code"] != null){
                            var label = subSetting["label"]
                            if (label == undefined) subSetting["label"] = subSetting["code"]
                            if (subSetting["class"] == undefined) subSetting["class"] = "col-md-12 no-gutter"

                            if(this.$attrs.formSettings != undefined){
                                if(this.$attrs.formSettings["name"] == undefined)
                                if(subSetting["defaultValue"] != undefined) this.settingsModel[subSetting["code"]] = subSetting["defaultValue"]
                            }else{
                                if(subSetting["defaultValue"] != undefined) this.settingsModel[subSetting["code"]] = subSetting["defaultValue"]
                            }

                            // Other Validations
                            switch(subSetting["type"]) {
                              case "select":
                                if(subSetting["options"] == undefined){
                                    if(subSetting["endpoint"] == undefined){
                                        subSettings.splice(i, 1);
                                    } else {
                                        if(subSetting["endpoint"].includes("http") || subSetting["endpoint"].includes("https")){
                                            var response = await HTTPRequest.getRequestThirdParty(subSetting["endpoint"], null)
                                            if(subSetting["endpoint"].includes("clp_licenses"))
                                                subSetting["options"] = response
                                            else
                                                subSetting["options"] = response.data
                                        } else {
                                            console.log("NOPEEE")
                                              var response = await HTTPRequest.getRequest(this.endPoint + subSetting["endpoint"], null)
                                              subSetting["options"] = response
                                        }
                                        if(subSetting["options"].length > 10){
                                            subSetting["sub_type"] = subSetting["type"]
                                            subSetting["type"] = "searchable_select"
                                        }
                                    }
                                }
                                break;
                              case "multiple_select":
                                if(subSetting["options"] == undefined){
                                    if(subSetting["endpoint"] == undefined){
                                        subSettings.splice(i, 1);
                                    } else {
                                        if(subSetting["endpoint"].includes("http") || subSetting["endpoint"].includes("https")){
                                            var response = await HTTPRequest.getRequestThirdParty(subSetting["endpoint"], null)
                                            if(subSetting["endpoint"].includes("clp_licenses"))
                                                subSetting["options"] = response
                                            else
                                                subSetting["options"] = response.data
                                        } else {
                                            var response = await HTTPRequest.getRequest(this.endPoint + subSetting["endpoint"], null)
                                            subSetting["options"] = response
                                        }

                                    //   var response = await HTTPRequest.getRequest(this.endPoint + subSetting["endpoint"], null)
                                    //   subSetting["options"] = response
                                    //   console.log(">>>>>>>>>>>")
                                    //   console.log(subSetting["options"])

                                      if(subSetting["options"].length > 100 || subSetting["options"].length == 0){
                                        subSetting["options"] = []
                                        subSetting["sub_type"] = subSetting["type"]
                                        subSetting["type"] = "searchable_select"
                                      }
                                    }
                                }
                                break;
                              default:
                                // code block
                            }
                       }
                    } else {
                        // console.log("Skipping -- invalid value")
                        subSettings.splice(i, 1);
                    }
                }
                // console.log(subSettings)
                subSettingArray.push(subSettings)
                // this.subGroupSettingsArray = subSettingArray
                this.subGroupSettingsArray = [].concat.apply([], subSettingArray)
                // console.log(this.subGroupSettingsArray)
                // groups[j]["subTerminalSettings"] = subSettings
            }
            }

            this.settingsGroupHash[groups[j]["name"]] = settingKeysArray

            // console.log("ANDITO NA")
            var settings = groups[j]["terminalSettings"]

            if(settings != undefined) {
            for(var i = 0; i < settings.length; i++){
                var setting = settings[i]
                if(types.includes(setting["type"])){
                   if(setting["code"] != "" || setting["code"] != null){
                        var label = setting["label"]
                        if (label == undefined) setting["label"] = setting["code"]
                        if (setting["class"] == undefined) setting["class"] = "col-md-12 no-gutter"

                        if(this.$attrs.formSettings != undefined){
                            if(this.$attrs.formSettings["name"] == undefined)
                            if(setting["defaultValue"] != undefined) this.settingsModel[setting["code"]] = setting["defaultValue"]
                        } else {
                            if(setting["defaultValue"] != undefined) this.settingsModel[setting["code"]] = setting["defaultValue"]
                        }

                        // if(this.$attrs.formSettings["name"] == undefined){
                        //     if(setting["defaultValue"] != undefined) this.settingsModel[setting["code"]] = setting["defaultValue"]
                        // }
                        // Other Validations
                        switch(setting["type"]) {
                          case "select":
                            if(setting["options"] == undefined || setting["options"].length == 0){
                                if(setting["endpoint"] == undefined){
                                    settings.splice(i, 1);
                                } else {

                                  if(setting["endpoint"].includes("http") || setting["endpoint"].includes("https")){
                                    // console.log("THIRD PARTYYY")
                                    var response = await HTTPRequest.getRequestThirdParty(setting["endpoint"], null)
                                    setting["options"] = response.data
                                  } else {
                                    //   console.log("NOPEEE")
                                    var response = await HTTPRequest.getRequest(this.endPoint + setting["endpoint"], null)
                                    setting["options"] = response
                                  }

                                //   var response = await HTTPRequest.getRequest(this.endPoint + setting["endpoint"], null)
                                //   setting["options"] = response
                                //   console.log("*****************")
                                //   console.log(setting["options"])
                                  if(setting["options"].length > 100 || setting["options"].length == 0){
                                      setting["options"] = []
                                      setting["sub_type"] = setting["type"]
                                      setting["type"] = "searchable_select"
                                  }
                                }
                            }
                            break;
                          case "cascader":
                                if(setting["endpoint"] == undefined){
                                    settings.splice(i, 1);
                                } else {
                                  if(setting["code"] == "categories"){
                                    setting["options"] = this.categoriesOptions
                                  } else {
                                    var response = await HTTPRequest.getRequest(this.endPoint + setting["endpoint"], null)
                                    setting["options"] = response
                                  }
                                }
                            break;
                          case "multiple_select":
                            if(setting["options"] == undefined){
                                if(setting["endpoint"] == undefined){
                                    settings.splice(i, 1);
                                } else {
                                    if(setting["endpoint"].includes("http") || setting["endpoint"].includes("https")){
                                        var response = await HTTPRequest.getRequestThirdParty(setting["endpoint"], null)
                                        setting["options"] = response.data
                                      } else {
                                        console.log("NOPEEE")
                                        var response = await HTTPRequest.getRequest(this.endPoint + setting["endpoint"], null)
                                        setting["options"] = response
                                      }

                                //   var response = await HTTPRequest.getRequest(this.endPoint + setting["endpoint"], null)
                                //   setting["options"] = response
                                //   console.log("*****************")
                                //   console.log(setting["options"])
                                  if(setting["options"].length > 100 || setting["options"].length == 0){
                                      setting["options"] = []
                                      setting["sub_type"] = setting["type"]
                                      setting["type"] = "searchable_select"
                                  }
                                }
                            }
                            break;
                          default:
                            // code block
                        }
                   }
                } else {
                    // console.log("Skipping -- invalid value")
                    settings.splice(i, 1);
                }
            }
            groups[j]["terminalSettings"] = settings
        }
        }

        // !!!! START --- Change this part for AXIOS - if for editing or with existing value for editing
        if(this.$attrs.formSettings != null)
            this.settingsModel = this.$attrs.formSettings

        // !!!! END

        if(this.$attrs.parameters != null){
            var settingsModelCopy = this.settingsModel
            var mergedHash = Object.assign({}, settingsModelCopy, JSON.parse(this.$attrs.parameters));
            this.settingsModel = mergedHash
            // console.log(this.settingsModel)
        }

        this.spinning = false
        this.settingsArray = groups
        // console.log(this.settingsArray)

     },

     onChange(checked){
        // console.log(`a-switch to ${checked}`);
     },
     changeValue(value){
         console.log("+++++++++++")
         console.log(value);
        var mergedValues = Object.assign({}, this.settingsModel, value);
        this.settingsModel = mergedValues
     },
     handleDatePickerChange(date, datestring, code){
         console.log("---date change---")
         console.log(datestring);
         console.log(code);
         this.settingsModel[code] = datestring;
     }

     // !!! END - DYNAMIC FORMS
  },
}
</script>

<style>

    .indent {
        padding-left: 45px;
    }

    .form-control {
        height: 35px;
    }

    .ant-calendar-picker {
        width: 100%
    }

    .dynamic-form > .ant-collapse {
        background-color: #F8F9FE;
        border: 0px;
    }

    .dynamic-form > .ant-collapse > .ant-collapse-item {
        border: 0px;
    }

    /* .dynamic-form > .ant-collapse > .ant-collapse-item-active > .ant-collapse-header{
        background-color: #F8F9FE;
        color:  black;
    } */
/*
    .dynamic-form > .ant-collapse > .ant-collapse-item-active > .ant-collapse-content-active{
        background-color: #F8F9FE;
    } */

    .dynamic-form > .ant-collapse .ant-collapse-item .ant-collapse-header .anticon {
        left: initial;
        right: 16px;
    }

    .product-advance-filter {
        padding: 0;
    }

</style>
